import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ToastProvider } from 'react-toast-notifications'
import Container from 'react-bootstrap/Container';
import Footer from './components/Footer/Footer';
import Routes from './Routes';
import Menu from './components/Menu/Menu';

import * as actions from './store/actions/index';
import './App.scss';

if (process.env.REACT_APP_GLOBAL_SCSS){
  require('./assets/scss/' + process.env.REACT_APP_GLOBAL_SCSS);
}

const App = (props) => {
  const [loading, setLoading] = useState(false);
  const [childProps, setChildProps] = useState();

  useEffect(() => {
      const checkAuth = async () => {
      setLoading(true);
      props.onCheckSignin();	
      props.onGetViewPerm();
      setChildProps({
        isAuthenticated: props.isAuthenticated });				
      setLoading(false); 
      }
      checkAuth(); 
      
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


return (           
  <div className="App">  
    <Menu {...props} />       
    <Container className="px-3" >
    <ToastProvider autoDismiss
      autoDismissTimeout={3000}> 
    { (!loading) ? (									                            
    <Routes childProps={childProps} {...props} />   
    ):''}                       
    </ToastProvider>
    </Container>
    <Footer {...props} />
  </div>
      );

}

const mapStateToProps = state => {
  return {
      isAuthenticated: state.auth.token !== null,
      authRedirectPath: state.auth.authRedirectPath,
      userFullname: state.auth.userFullname,
      user: state.auth.user,
      viewPermissions: state.auth.viewPermissions,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLogout: () => dispatch(actions.logout()),
    onCheckSignin: () => dispatch(actions.authCheckState() ),
    onSetAuthRedirectPath: (path) => dispatch(actions.setAuthRedirectPath(path)),
    onGetViewPerm: () => dispatch(actions.getViewPerm())
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps )(App));
